import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledImpactBox = styled.div`
  width: 48px;
  height: 48px;
  border-radius: ${theme.variables.border_radius_1};
  background-color: ${theme.colors.purple_2};
  display: flex;
  align-items: center;
  justify-content: center;
`;
